module.exports = __webpack_public_path__ + "img/photo2_8.93414992.jpg";